import React from "react";
import Box from "@mui/material/Box";

const GlobalFooter: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                width: "100%",
                py: 2,
                px: 1,
                backgroundColor: "#ECEFF3",
                textAlign: "center",
                position: "fixed",
                bottom: 0,
                left: 0,
                borderTop: "1px solid #ddd",
                fontSize: "0.95rem",
                zIndex: 1201
            }}
        >
            <span>&copy; 2026 - Burgess &amp; Niple, Inc | </span>
            <a href="https://www.burgessniple.com/terms-of-use/" style={{ color: "inherit", textDecoration: "underline" }}>Terms of Use</a>
            <span> | </span>
            <a href="https://www.burgessniple.com/privacy-policy/" style={{ color: "inherit", textDecoration: "underline" }}>Privacy Policy</a>
            <span> | </span>
            <a href="https://health1.aetna.com/app/public/#/one/insurerCode=AETNACVS_I&brandCode=ALICSI/machine-readable-transparency-in-coverage?reportingEntityType=Third%20Party%20Administrator_12427391&lock=true" style={{ color: "inherit", textDecoration: "underline" }}>Transparency in Coverage</a>
        </Box>
    );
};

export default GlobalFooter;
